import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

/**
* @desc reducer for review candidate
* @version
* @author Lakshmikanth 
* @return updated state
*/
const initialState = {
    groupedPool: {}
};

const setGroupTalentPool = ( state = initialState , action ) => {
  const groupedPool = {...action.talentPool};
  return updateObject( state, { groupedPool : groupedPool } );   
};

const clearReduxState = ( state = initialState , action ) => {
  return updateObject( state, initialState );   
};



const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SET_GROUP_TALENTPOOL: 
      return setGroupTalentPool(state, action);  
    case actionTypes.COGNITO_LOGOUT:
      return clearReduxState(state,action);  
          
    default:
      return state;
  }
};

export default reducer;




// WEBPACK FOOTER //
// ./src/store/reducers/candidateReview.js